export const PortalFacebookIcon = require('./facebook_icon.svg');
export const PortalInstagramIcon = require('./instagram_icon.svg');
export const PortalLinkedInIcon = require('./linkedIn_icon.svg');
export const PortalTwitterIcon = require('./twitter_icon.svg');
export const PortalYoutubeIcon = require('./youtube_icon.svg');
export const PortalFooterLogo = require('./jyu_logo.svg');
